// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.File__container-e5b8b4 {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/Article/ArticleRedactor/Payloads/File/File.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF","sourcesContent":[".container {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `File__container-e5b8b4`
};
module.exports = ___CSS_LOADER_EXPORT___;
